// extracted by mini-css-extract-plugin
export var component = "DashboardMenuLink-module--component--egDIg";
export var current = "DashboardMenuLink-module--current--cDUIw";
export var inert = "DashboardMenuLink-module--inert--P4SuC";
export var label = "DashboardMenuLink-module--label--EqmuI";